import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import { CodeBracketIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { MdFeedback } from "react-icons/md"
import { classNames } from '../../utils'

interface FeedbackConfirmationProps {
  isOpen: boolean
  onClose: () => void
}

export function FeedbackConfirmation({ isOpen, onClose }: FeedbackConfirmationProps) {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-20" onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white dark:bg-neutral-900 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white dark:bg-neutral-900 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                    
                      <div className="mt-3 text-center sm:mt-0  sm:text-left">
                        <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900 dark:text-white">
                        🎉 Thank You for Your Feedback!
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500 dark:text-gray-300">
                          We've received your corrections and your credits are on their way. You're making a real difference!                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 dark:bg-neutral-800 px-4 py-3 sm:flex sm:flex-row sm:px-6 justify-center">
                    <button
                      type="button"
                      className={classNames(
                        "w-full mr-4 justify-center rounded-md border border-transparent  px-4 py-2 text-base font-medium text-black dark:text-white  sm:ml-3 sm:w-auto sm:text-sm",
                        "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
                        "hover:scale-105 duration-150"
                      )}
                      onClick={onClose}
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
